import { render, staticRenderFns } from "./EmojiLibrary.vue?vue&type=template&id=2198cbdb"
import script from "./EmojiLibrary.vue?vue&type=script&lang=js"
export * from "./EmojiLibrary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports